import { Injectable } from '@angular/core';
import { ApplicationEvent } from '~shared/modules/application-event/models';
import { Observable, ReplaySubject } from 'rxjs';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { LoggerService } from '~shared/modules/logger/services/logger.service';
import { LoggerStrategies } from '~shared/modules/logger/models';
import { GA_EVENT_SERVER_LOG_KEY } from '~shared/constants';

@Injectable({
  providedIn: 'root',
})
export class ApplicationEventService {
  constructor(
    private readonly featureToggleService: ActiveFeaturesConfigcatService,
    private loggerService: LoggerService
  ) {}

  private events$ = new ReplaySubject<ApplicationEvent>();

  public subscribe(): Observable<ApplicationEvent> {
    return this.events$.asObservable();
  }

  /**
   * @deprecated use gtagEvent in gtm-datalayer.service.ts instead
   */
  public publish(event: ApplicationEvent, enableServerLogger = false) {
    this.events$.next(event);
    if (enableServerLogger) {
      this.loggerService.info(GA_EVENT_SERVER_LOG_KEY, event, LoggerStrategies.serverLogger);
    }
  }
  public publishIfFFEnabled(featureFlag: string, event: ApplicationEvent, enableServerLogger = false) {
    this.featureToggleService.isFeatureEnabledReadyForCurrentCountry$(featureFlag).subscribe((enabled) => {
      if (enabled) {
        this.publish(event, enableServerLogger);
      }
    });
  }
}
